// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"MaintenanceContractTypesList_tabHeader__3w931"};